<template>
  <div>
    <p class="text-body-2">
      ¿De qué canal te gustaría visualizar la información?
    </p>
    <div class="d-flex text-center justify-center">
      <v-card elevation="1" outlined bordered>
        <v-tabs
          v-model="selectedChannelIndex"
          :vertical="vertical"
          center-active
          color="white"
        >
          <v-tab
            v-for="channel in selectableChannels"
            :key="channel.value"
            :disabled="disabled || loading"
            active-class="channel-selector__item--selected rounded text-white"
          >
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="white"
              size="20"
              class="mx-1"
            />
            {{ channel.label }}
          </v-tab>
        </v-tabs>
      </v-card>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { Channels } from '@/core/constants/channelConstants';

  export default {
    name: 'ChannelSelector',
    props: {
      channels: {
        type: Array,
        default: () => [Channels.RETAIL, Channels.WHOLESALER],
      },
      defaultChannel: {
        type: String,
        default: null,
      },
      withAllChannelsOption: Boolean,
      vertical: Boolean,
      disabled: Boolean,
      loading: Boolean,
    },
    data() {
      return {
        selectedChannelIndex: 0,
      };
    },
    computed: {
      ...mapGetters('auth', ['user']),

      availableChannels() {
        return (this.channels ?? [])
          .filter((code) => Object.values(Channels).includes(code))
          .map((code) => ({
            value: code,
            label: `${code} - ${this.user.channels[code]}`,
          }));
      },

      selectableChannels() {
        const channels = [...this.availableChannels];
        if (this.withAllChannelsOption) {
          channels.push({
            value: '',
            label: 'Todos los canales',
          });
        }
        return channels;
      },
    },
    watch: {
      selectedChannelIndex(newIndex) {
        const selectedChannel = this.selectableChannels[newIndex]?.value;
        this.$emit('channelSelected', selectedChannel);
      },
    },
    created() {
      const selectedValue =
        this.defaultChannel ||
        this.user.VTWEG ||
        this.availableChannels[0]?.value;

      const index = this.selectableChannels.findIndex(
        ({ value }) => value === selectedValue
      );

      // if the index doesn't change, the watch below never fires, so emit manually
      if (index === this.selectedChannelIndex) {
        this.$emit('channelSelected', selectedValue);
      } else {
        this.selectedChannelIndex = index;
      }
    },
  };
</script>

<style scoped>
  .channel-selector__list {
    border: 1px solid #686868;
    width: 400px;
  }

  .channel-selector__item--selected {
    cursor: default;
    background-color: #686868;
    color: #fff;
  }
</style>
